const PATH_PREFIX = '/super';

export default [
  {
    name: 'super.dashboard',
    path: `${PATH_PREFIX}/dashboard`,
  },
  {
    name: 'super.chatrooms',
    path: `${PATH_PREFIX}/chatrooms`,
  },
  {
    name: 'super.companies',
    path: `${PATH_PREFIX}/companies`,
  },
  {
    name: 'super.minisites',
    path: `${PATH_PREFIX}/minisites`,
  },
  {
    name: 'super.countries',
    path: `${PATH_PREFIX}/countries`,
  },
  {
    name: 'super.currencies',
    path: `${PATH_PREFIX}/currencies`,
  },
  {
    name: 'super.articles',
    path: `${PATH_PREFIX}/articles`,
  },
  {
    name: 'super.article.detail',
    path: `${PATH_PREFIX}/article/:docID`,
  },
  {
    name: 'super.keywords.brands',
    path: `${PATH_PREFIX}/keywords/brands`,
  },
  {
    name: 'super.keywords.classifications',
    path: `${PATH_PREFIX}/keywords/classifications`,
  },
  {
    name: 'super.keywords.tags',
    path: `${PATH_PREFIX}/keywords/tags`,
  },
  {
    name: 'super.languages',
    path: `${PATH_PREFIX}/languages`,
  },
  {
    name: 'super.products',
    path: `${PATH_PREFIX}/products`,
  },
  {
    name: 'super.users',
    path: `${PATH_PREFIX}/users`,
  },
  {
    name: 'super.sms.template',
    path: `${PATH_PREFIX}/sms/template`,
  },
  {
    name: 'super.code.list',
    path: `${PATH_PREFIX}/code`,
  },
  {
    name: 'super.code.detail',
    path: `${PATH_PREFIX}/code/:docID`,
  },
  {
    name: 'super.payment_method.list',
    path: `${PATH_PREFIX}/payment_methods`,
  },
  {
    name: 'super.payment_method.detail',
    path: `${PATH_PREFIX}/payment_methods/:docID`,
  },
  {
    name: 'super.subscriptions',
    path: `${PATH_PREFIX}/subscriptions`,
  },
  {
    name: 'super.supports',
    path: `${PATH_PREFIX}/supports`,
  },
  // // procurements
  {
    name: 'super.procurement.enquiries',
    path: `${PATH_PREFIX}/procurement/enquiries`,
  },
  {
    name: 'super.procurement.enquiry',
    path: `${PATH_PREFIX}/procurement/enquiry/:docID`,
  },
  {
    name: 'super.procurement.requestForQuotes',
    path: `${PATH_PREFIX}/procurement/request_for_quotes`,
  },
  {
    name: 'super.procurement.requestForQuote',
    path: `${PATH_PREFIX}/procurement/request_for_quote/:docID`,
  },
  {
    name: 'super.procurement.transactions',
    path: `${PATH_PREFIX}/procurement/transactions`,
  },
  {
    name: 'super.procurement.transaction',
    path: `${PATH_PREFIX}/procurement/transaction/:docID`,
  },
  {
    name: 'super.procurement.orders',
    path: `${PATH_PREFIX}/procurement/orders`,
  },
  {
    name: 'super.procurement.order',
    path: `${PATH_PREFIX}/procurement/order/:docID`,
  },
  {
    name: 'super.procurement.quotations',
    path: `${PATH_PREFIX}/procurement/quotations`,
  },
  {
    name: 'super.procurement.quotation',
    path: `${PATH_PREFIX}/procurement/quotation/:docID`,
  },
  {
    name: 'super.procurement.invoices',
    path: `${PATH_PREFIX}/procurement/invoices`,
  },
  {
    name: 'super.procurement.invoice',
    path: `${PATH_PREFIX}/procurement/invoice/:docID`,
  },
  {
    name: 'super.procurement.deliveryNotes',
    path: `${PATH_PREFIX}/procurement/delivery_notes`,
  },
  {
    name: 'super.procurement.deliveryNote',
    path: `${PATH_PREFIX}/procurement/delivery_note/:docID`,
  },
  {
    name: 'super.script',
    path: `${PATH_PREFIX}/script`,
  },
];
